window.onload = () => {
  const leftCol = document.querySelector('.left-col');
  const header = document.getElementById('header');
  const footer = document.getElementById('footer');
  const content = document.getElementById('content');
  const notice = document.getElementById('header_notice');
  let height = window.innerHeight;
  // 高さからヘッダー分を減らす
  if (header != null) {
    height = height - header.offsetHeight;
  }
  if (notice != null) {
    height = height - notice.offsetHeight;
  }
  // 左コンテンツ
  if (leftCol != null) {
    (leftCol as HTMLElement).style.minHeight = height + 'px';
  }
  // 右コンテンツ
  if (footer != null && content != null) {
    height = height - footer.offsetHeight;
    content.style.minHeight = height + 'px';
  }
};
